import React, { useState, useEffect } from 'react';
import { isTablet } from 'react-device-detect';
import './TabletOrientationGuard.css';

interface TabletOrientationGuardProps {
    children: React.ReactNode;
}

const TabletOrientationGuard: React.FC<TabletOrientationGuardProps> = ({ children }) => {
    const [isPortrait, setIsPortrait] = useState(
        () => window.innerWidth < window.innerHeight
    );

    useEffect(() => {
        if (!isTablet) return;

        const update = () => setIsPortrait(window.innerWidth < window.innerHeight);
        window.addEventListener('resize', update);
        window.addEventListener('orientationchange', update);
        return () => {
            window.removeEventListener('resize', update);
            window.removeEventListener('orientationchange', update);
        };
    }, []);

    if (isTablet && isPortrait) {
        return (
            <div className="spona-orientation-guard">
                <div className="spona-orientation-guard-content">
                    <div className="spona-orientation-guard-icon" aria-hidden="true">
                        <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                            {/* Device outline */}
                            <rect
                                x="18" y="6" width="28" height="44"
                                rx="4" ry="4"
                                stroke="currentColor" strokeWidth="2.5" fill="none"
                            />
                            {/* Home button */}
                            <circle cx="32" cy="45" r="2" fill="currentColor" />
                            {/* Rotation arrow */}
                            <path
                                d="M46 20 A18 18 0 0 1 32 54"
                                stroke="var(--spona-brand-primary)" strokeWidth="2.5"
                                fill="none" strokeLinecap="round"
                            />
                            <polyline
                                points="28,50 32,54 36,50"
                                stroke="var(--spona-brand-primary)" strokeWidth="2.5"
                                fill="none" strokeLinecap="round" strokeLinejoin="round"
                            />
                        </svg>
                    </div>
                    <h2 className="spona-orientation-guard-title">Okrenite uređaj</h2>
                    <p className="spona-orientation-guard-subtitle">
                        Aplikacija je optimizovana za horizontalni prikaz
                    </p>
                </div>
            </div>
        );
    }

    return <>{children}</>;
};

export default TabletOrientationGuard;
